import React from 'react';

export type ButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'color'
> & {
  loading?: boolean;
  size?: string;
  basic?: boolean;
  positive?: boolean;
  negative?: boolean;
  color?: string;
  as?: React.ElementType;
  href?: string;
  target?: string;
  rel?: string;
};

const Spinner = () => (
  <span className="inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
);

const sizeClasses = (size?: string) =>
  size === 'large' ? '!h-14 !px-[30px] !rounded-[28px]' : '';

const makeButton =
  (colorClasses: string) =>
  ({
    loading,
    size,
    basic: _basic,
    positive: _positive,
    negative: _negative,
    color: _color,
    as: As,
    className = '',
    children,
    ...props
  }: ButtonProps) => {
    const classes = `h-12 px-4 flex items-center justify-center rounded-full border font-medium cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses(
      size,
    )} ${colorClasses} ${className}`;
    const Tag = As ?? 'button';
    return (
      <Tag className={classes} {...props}>
        {loading ? <Spinner /> : children}
      </Tag>
    );
  };

const BasicButton = makeButton(
  'border-primary bg-white text-primary hover:bg-primary-light',
);
const PositiveButton = makeButton(
  'border-primary bg-primary text-white hover:bg-primary-hover',
);
const NegativeButton = makeButton(
  'border-neutral-300 bg-white text-neutral-900 hover:bg-neutral-900 hover:text-white',
);
const GreenButton = makeButton(
  'border-success bg-success text-white hover:bg-success-hover',
);

export {BasicButton, PositiveButton, NegativeButton, GreenButton};
